import React, { ChangeEvent, FC, useRef } from 'react';
import classNames from 'classnames';

import { ACCEPTED_CHAT_FILE_TYPES_STRING } from '@sv-support-sdk/utils/src/constants/attachments';

import css from './style.module.scss';

import Button from '../ui/Controls/Button';
import { useAppDispatch } from '../../store/hooks';
import { sendAttachment } from '../../store/actions/messages';
import setQaAttribute from '../../helpers/setQaAttribute';
import { ATTACHMENT_BUTTON } from '../../constants/qaAttributes';

interface IAttachmentButton {
  visible: boolean;
}

const AttachmentsButton: FC<IAttachmentButton> = ({ visible }) => {
  const fileInput = useRef<HTMLInputElement | null>(null);
  const dispatch = useAppDispatch();
  const fileChoose = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(sendAttachment(event.target));
  };
  return (
    <div className={classNames(css.chat__controlsButton, { [css.isHidden]: !visible })}>
      <input
        ref={fileInput}
        type="file"
        id="fileInput"
        style={{ display: 'none' }}
        multiple
        onChange={fileChoose}
        accept={ACCEPTED_CHAT_FILE_TYPES_STRING}
      />
      <Button
        icon="24--attach-file"
        iconSize="24"
        radius="circle"
        shape="square"
        size="small"
        variant="icon"
        {...setQaAttribute(ATTACHMENT_BUTTON)}
        onClick={() => fileInput.current?.click()}
      />
    </div>
  );
};

export default AttachmentsButton;
